import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/global.css'
import { App } from './App'

// Marks that React actually mounted — the standalone export's static skeleton
// (captureLiveDashboardSnapshot in exportToStandaloneHtml.ts) is a frozen
// clone of this same DOM, so CSS keys off this class to pick exactly one
// sidebar-highlight mechanism per context (see Dashboard.module.css):
// scroll-spy once this class is present, :target/scroll-timeline fallback
// when it's absent (JavaScript-disabled preview).
document.documentElement.classList.add('js-enabled')

const root = document.getElementById('root')!
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
